import type { CarDTO } from '@/features/api/extranet/dto/Demande/CAR'
import { PropertyStatus, type PropertyStatusConfiguration } from '@/features/domaine/property-status'
import type { ContextReglesCar } from './types'

export const propertyStatusConfiguration: PropertyStatusConfiguration<CarDTO, ContextReglesCar> = {
  sousDispositif: PropertyStatus.Required,
  lieuSignature: PropertyStatus.NotPresent,
  attestationPiecesJustificatives: PropertyStatus.Required,

  employeur: {
    contact: {
      email: PropertyStatus.Required,
    },
  },

  attestationSurHonneur: PropertyStatus.Required,
  acceptationCg: PropertyStatus.Required,
} as const
